<template>
    <div class="item-menu-mobile" @click="handleClick" :class="props.isActive ? 'item-menu-mobile-active' :  'item-menu-mobile-inactive'">
        <div class="flex items-center justify-center text-2xl">
            <i :class="props.item.icon"></i>
        </div>
        <div class="flex items-center justify-center text-sm pt-2 text-center">
            <span class="truncate px-1">{{ props.item.name }}</span>
        </div>
    </div>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue';
const props = defineProps({
    item: {
        type: Object,
        required: true
    },
    isActive: {
        type: Boolean,
        required: true
    }
})

const emit = defineEmits(['click']);

const handleClick = () => {
    emit('click', props.item);
}
</script>

<style scoped lang="postcss">
.item-menu-mobile {
    @apply h-24 w-24 rounded-xl shadow-lg shadow-echoes-background-gray/50 flex flex-col items-center justify-center py-4 transition-all duration-300 flex-shrink-0;
}
.item-menu-mobile-active {
    @apply bg-echoes-primary;
}
.item-menu-mobile-inactive {
    @apply bg-echoes-background-gray;
}
</style>